import { useState } from 'react';
import { Trans } from 'react-i18next';

import Button from 'components/field/Button';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faChevronDown, faChevronUp, faLockOpen } from '@fortawesome/pro-regular-svg-icons';

import * as S from './SalesChannelFeatues.styled';

const SalesChannelFeatures = ({ features }) => {
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const [showAll, setShowAll] = useState(false);

	const displayedFeatures = isMobile && !showAll ? features.slice(0, 3) : features;
	return (
		<div>
			<Typography variant="p2" fontWeight="700">
				<Trans
					i18nKey="availableFeaturesCount"
					values={{
						count: features.length
					}}
				/>
			</Typography>
			<S.FeaturesGrid>
				{displayedFeatures.map((feature) => (
					<S.Feature key={feature.key}>
						<S.FeatureIcon icon={faLockOpen} />
						<S.FeatureContent>
							<Typography variant="p3" fontWeight="500" noWrap>
								{feature.title}
							</Typography>
							<Typography variant="caption" noWrap color="var(--content-3)">
								{feature.description}
							</Typography>
						</S.FeatureContent>
					</S.Feature>
				))}
			</S.FeaturesGrid>
			{isMobile && features.length > 3 && (
				<Button
					variant="text"
					fullWidth
					icon={showAll ? faChevronUp : faChevronDown}
					iconPos="right"
					label={showAll ? 'showLess' : `showMore`}
					onClick={() => setShowAll(!showAll)}
					css={{ marginTop: '1.6rem' }}
				/>
			)}
		</div>
	);
};

export default SalesChannelFeatures;
